import { uploadExpenseInvoice } from "../api"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";

export const uploadInvoiceFile = async (file) => {
  var formdata = new FormData()
  formdata.append("file", file)
  return uploadExpenseInvoice(formdata)
}

export const formatDateAgo = (date) => {
  dayjs.extend(relativeTime);
  dayjs.extend(timezone);
  dayjs.locale('en');
  dayjs.tz.setDefault();
  
  const now = dayjs();
  const dateObj = dayjs(date);
  const diffInDays = now.diff(dateObj, 'day');

  if (diffInDays > 1) {
    return dayjs(date).fromNow();
  } else {
    return dayjs(date).format("HH:MM A");
  }
};